import { MODULES } from "../../lib/modules";

/**
 * ModuleChecklist — checkbox grid of module keys.
 * `available` optionally limits which modules can be picked (for per-user
 * overrides that must be a subset of the org's grants).
 */
export default function ModuleChecklist({ value = [], onChange, available, testidPrefix = "mod" }) {
  const pool = available ? MODULES.filter((m) => available.includes(m.key)) : MODULES;
  const toggle = (key) => {
    if (value.includes(key)) onChange(value.filter((k) => k !== key));
    else onChange([...value, key]);
  };
  const allKeys = pool.map((m) => m.key);
  const allOn = allKeys.every((k) => value.includes(k)) && allKeys.length > 0;

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <span className="text-[12px] font-bold small-caps" style={{ color: "var(--cv-dark-grey)" }}>
          {value.length} of {pool.length} enabled
        </span>
        <button
          type="button"
          data-testid={`${testidPrefix}-toggle-all`}
          className="text-[12px] font-bold"
          style={{ color: "var(--cv-crimson)" }}
          onClick={() => onChange(allOn ? [] : allKeys)}
        >
          {allOn ? "Clear all" : "Select all"}
        </button>
      </div>
      <div className="grid grid-cols-2 gap-1.5 max-h-[240px] overflow-y-auto pr-1">
        {pool.map((m) => {
          const on = value.includes(m.key);
          return (
            <label
              key={m.key}
              data-testid={`${testidPrefix}-${m.key}`}
              className="flex items-center gap-2 px-2.5 py-2 rounded cursor-pointer text-[13px]"
              style={{ border: "1px solid var(--cv-line)", background: on ? "rgba(62,124,79,0.08)" : "#fff" }}
            >
              <input type="checkbox" checked={on} onChange={() => toggle(m.key)} className="accent-[var(--cv-crimson)]" />
              <span style={{ color: "var(--cv-charcoal)" }}>{m.label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
}
